<app-loinc-list-display *ngIf="!isDetailView()" [primaryKey]="key" [loincService]="loincTableService"></app-loinc-list-display>

<div *ngIf="isDetailView()" class="flex justify-center">
    <div class="w-1/5"></div>
    <div class="flex flex-col space-y-8 flex-1">
        <div class="flex space-x-8">
            <div class="flex flex-col space-y-2">
                <span class="text-gray-600 text-lg text-nowrap">{{ headerFields.number?.verbose_name }}</span>
                <span class="font-semibold text-3xl text-nowrap">{{ headerFields.number?.value }}</span>
            </div>
            <div class="flex flex-col flex-grow space-y-2 min-w-0">
                <span class="text-gray-600 text-lg">{{ headerFields.long_common_name?.verbose_name }}</span>
                <span class="font-semibold text-3xl break-all">{{ headerFields.long_common_name?.value }}</span>
            </div>
            <div class="flex flex-col space-y-2">
                <span class="text-gray-600 text-lg text-nowrap">{{ headerFields.status?.verbose_name }}</span>
                <span class="font-semibold text-3xl text-nowrap">{{ headerFields.status?.value }}</span>
            </div>
        </div>
        <app-loinc-detail-display class="flex-1" [result]="singleResult" [feedbackURL]="getFeedbackURL()"></app-loinc-detail-display>
    </div>
    <div class="w-1/5"></div>
</div>
